/**
 * @generated SignedSource<<af2660d441125c4e4bac2f96e801c03d>>
 * @relayHash 87bd514c61c54056c9bc44eb7829f5c1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6034f67e4acab424f0f79800b863701f550bb75dfbd479611f493b8bffc2205c

import type { ConcreteRequest } from 'relay-runtime';
export type PageOwnershipByLineWithCollaboratorsDropdownContentQuery$variables = {
  cloudId: string;
  first: number;
  id: string;
  shouldIncludeJobTitle: boolean;
  spaceKey: string;
};
export type PageOwnershipByLineWithCollaboratorsDropdownContentQuery$data = {
  readonly confluence_contentCollaborators: {
    readonly count: number | null;
    readonly nodes: ReadonlyArray<{
      readonly agent: {
        readonly accountId: string;
        readonly displayName: string | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
      } | null;
      readonly person: {
        readonly accountId?: string | null;
        readonly displayName: string | null;
        readonly jobTitle?: string | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
        readonly type: string | null;
      };
    } | null> | null;
  } | null;
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly status: string | null;
    } | null> | null;
  } | null;
  readonly space: {
    readonly currentUser: {
      readonly isAdmin: boolean;
    };
    readonly id: string | null;
  } | null;
};
export type PageOwnershipByLineWithCollaboratorsDropdownContentQuery = {
  response: PageOwnershipByLineWithCollaboratorsDropdownContentQuery$data;
  variables: PageOwnershipByLineWithCollaboratorsDropdownContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldIncludeJobTitle"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v5 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "args": [
    (v5/*: any*/),
    {
      "kind": "Literal",
      "name": "status",
      "value": [
        "current",
        "draft",
        "archived"
      ]
    }
  ],
  "concreteType": "PaginatedContentListWithChild",
  "kind": "LinkedField",
  "name": "content",
  "plural": false,
  "selections": [
    {
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v6/*: any*/),
        {
          "kind": "ScalarField",
          "name": "status"
        }
      ]
    }
  ]
},
v8 = {
  "args": [
    {
      "kind": "Variable",
      "name": "key",
      "variableName": "spaceKey"
    }
  ],
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "concreteType": "SpaceUserMetadata",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isAdmin"
        }
      ]
    }
  ]
},
v9 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  (v5/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "name": "count"
},
v11 = {
  "kind": "ScalarField",
  "name": "type"
},
v12 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v13 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v14 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    {
      "condition": "shouldIncludeJobTitle",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "jobTitle"
        }
      ]
    }
  ],
  "type": "KnownUser"
},
v16 = {
  "concreteType": "ConfluenceAgent",
  "kind": "LinkedField",
  "name": "agent",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v14/*: any*/),
    (v13/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PageOwnershipByLineWithCollaboratorsDropdownContentQuery",
    "selections": [
      (v7/*: any*/),
      (v8/*: any*/),
      {
        "args": (v9/*: any*/),
        "concreteType": "ConfluenceCollaboratorConnection",
        "kind": "LinkedField",
        "name": "confluence_contentCollaborators",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "concreteType": "ConfluenceCollaborator",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v15/*: any*/)
                ]
              },
              (v16/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "PageOwnershipByLineWithCollaboratorsDropdownContentQuery",
    "selections": [
      (v7/*: any*/),
      (v8/*: any*/),
      {
        "args": (v9/*: any*/),
        "concreteType": "ConfluenceCollaboratorConnection",
        "kind": "LinkedField",
        "name": "confluence_contentCollaborators",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "concreteType": "ConfluenceCollaborator",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v15/*: any*/)
                ]
              },
              (v16/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "87bd514c61c54056c9bc44eb7829f5c1",
    "id": "6034f67e4acab424f0f79800b863701f550bb75dfbd479611f493b8bffc2205c",
    "metadata": {},
    "name": "PageOwnershipByLineWithCollaboratorsDropdownContentQuery",
    "operationKind": "query",
    "text": "query PageOwnershipByLineWithCollaboratorsDropdownContentQuery($cloudId:ID!,$id:ID!,$spaceKey:String!,$first:Int!,$shouldIncludeJobTitle:Boolean!){content(id:$id,status:[\"current\",\"draft\",\"archived\"]){nodes{id,status}},space(key:$spaceKey){id,currentUser{isAdmin}},confluence_contentCollaborators(cloudId:$cloudId,id:$id,first:$first){count,nodes{person{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,jobTitle@include(if:$shouldIncludeJobTitle)}},agent{displayName,accountId,profilePicture{path}}}}}"
  }
};
})();

(node as any).hash = "c0bda5775ae1a53e6d90777fe11b5bc2";

export default node;
